import { AxiosRequestConfig } from 'axios';

import { httpApiClient } from 'configs/http-client';
import { GetListPayload, ShareExchangeRequestsResponse } from 'interfaces';
import {
  ExternalShareExchangePayload,
  SingleExternalShareExchange,
} from 'interfaces/external-share-exchange.interface';
import { stringifyFilterParams } from 'utils';

export class ExternalShareExchangeApis {
  constructor(private url: string) {}

  createExternalShareExchange(payload: FormData, config?: AxiosRequestConfig) {
    return httpApiClient.post<{ data: ExternalShareExchangePayload }>(`${this.url}`, payload, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      ...config,
    });
  }
  getExternalShareExchange(id: string, config?: AxiosRequestConfig) {
    return httpApiClient.get<{ data: SingleExternalShareExchange }>(`${this.url}/${id}`, config);
  }
  getExternalShareExchanges(params: GetListPayload, config?: AxiosRequestConfig) {
    return httpApiClient.get<ShareExchangeRequestsResponse>(`${this.url}?${stringifyFilterParams(params)}`, config);
  }

  deleteExternalShareExchange(id: number, config?: AxiosRequestConfig) {
    return httpApiClient.delete(`${this.url}/${id}`, config);
  }
}

export const adminCreateExternalSharesApis = new ExternalShareExchangeApis('/admin/share-exchanges/external/create');
export const investorExternalSharesApis = new ExternalShareExchangeApis('investors/external-deal');
export const adminExternalSharesApis = new ExternalShareExchangeApis('admin/external-deal');
